import React from "react";

class Header extends React.Component {
  constructor() {
    super();
    /* this.toggleNav = this.toggleNav.bind(this);*/
    this.state = { showNav: false, showSearch: false };
  }

  toggleNav() {
    console.log(this);
    console.log("toggleNav");

    this.setState(previousState => {
      return { showNav: !previousState.showNav };
    });
  }

  toggleSearch() {
    console.log("toggleSearch");

    this.setState(previousState => {
      return { showSearch: !previousState.showSearch };
    });
  }

  render() {
    if (this.state.showNav) {
      var nav = this.renderNav();
    } else {
      var nav = "";
    }

    if (this.state.showSearch) {
      var search = this.renderSearch();
      top = "";
    } else {
      var search = "";
      var top = this.renderTop();
    }

    return (
      <header className="header">
        {top}
        {search}
        {nav}
      </header>
    );
  }

  renderTop() {
    return (
      <div className="top">
        <div
          className="hamburger_wrap"
          onClick={this.toggleNav.bind(this)}
          data-ga-event-category="Hamburger Nav Expand Mobile"
          data-ga-event-action="click"
          data-ga-on="click"
        >
          <div className="hamburger">ham</div>
        </div>
        <div
          className="header_logo_wrap"
          data-ga-event-category="Logo Nav"
          data-ga-event-action="click"
          data-ga-on="click"
        >
          <a href="/">
            <div className="header_logo">The FADER</div>
          </a>
        </div>
        <div
          className="search_wrap"
          onClick={this.toggleSearch.bind(this)}
          data-ga-event-category="Search Nav Expand Mobile"
          data-ga-event-action="click"
          data-ga-on="click"
        >
          <div className="search">search</div>
        </div>
      </div>
    );
  }

  renderNav() {
    return (
      <div className="nav_wrapper">
        <nav>
          <a
            href="/music"
            data-ga-event-category="Music Nav Mobile"
            data-ga-event-action="click"
            data-ga-on="click"
          >
            Music
          </a>
          <a
            href="/style"
            data-ga-event-category="Style Nav Mobile"
            data-ga-event-action="click"
            data-ga-on="click"
          >
            Style
          </a>
          <a
            href="/culture"
            data-ga-event-category="Culture Nav Mobile"
            data-ga-event-action="click"
            data-ga-on="click"
          >
            Culture
          </a>
          <a
            href="/magazine"
            data-ga-event-category="Magazine Nav Mobile"
            data-ga-event-action="click"
            data-ga-on="click"
          >
            Magazine
          </a>
          <a
            href="https://shop.thefader.com"
            data-ga-event-category="Shop Nav Mobile"
            data-ga-event-action="click"
            data-ga-on="click"
          >
            Shop
          </a>
        </nav>
        <div className="sub_nav">
          <a
            href="https://www.facebook.com/thefader"
            target="new"
            className="facebook"
            data-ga-event-category="Facebook Nav Mobile"
            data-ga-event-action="click"
            data-ga-on="click"
          >
            facebook
          </a>
          <a
            href="https://twitter.com/thefader"
            target="new"
            className="twitter"
            data-ga-event-category="Twitter Nav Mobile"
            data-ga-event-action="click"
            data-ga-on="click"
          >
            twitter
          </a>
          <a
            href="https://www.instagram.com/thefader"
            target="new"
            className="instagram"
            data-ga-event-category="Instagram Nav Mobile"
            data-ga-event-action="click"
            data-ga-on="click"
          >
            instagram
          </a>
        </div>
      </div>
    );
  }

  renderSearch() {
    return (
      <div className="top">
        <form
          className="search_form"
          action="/search"
          method="GET"
          data-ga-event-category="Search Nav Execute Mobile"
          data-ga-event-action="click"
          data-ga-on="click"
        >
          <input
            autoFocus
            type="text"
            name="query"
            placeholder="Press Enter to Search"
          />
        </form>

        <div className="search_wrap" onClick={this.toggleSearch.bind(this)}>
          <div className="search_close">close</div>
        </div>
      </div>
    );
  }
}

export default Header;
